(() => {
  const selector = '[data-product-reviews], [data-koala-section="reviews"], [data-rb-block="reviews"], .rbe-reviews';
  const sync = () => document.querySelectorAll(selector).forEach(section => {
    const widget = section.querySelector('.jdgm-rev-widg');
    const raw = widget?.getAttribute('data-number-of-reviews');
    const count = raw != null && raw.trim() !== '' ? Number(raw) : NaN;
    const hasReviews = Number.isFinite(count) ? count > 0 :
      [...section.querySelectorAll('.jdgm-rev__body')].some(body => body.textContent.trim());
    const value = String(hasReviews);
    if (section.dataset.hasReviews !== value) section.dataset.hasReviews = value;
  });
  const start = () => {
    sync();
    const observer = new MutationObserver(sync);
    observer.observe(document.body, {subtree: true, childList: true,
      attributes: true, attributeFilter: ['data-number-of-reviews']});
    document.addEventListener('shopify:section:load', sync);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
